import { EntityLayout } from "@backstage/plugin-catalog";
import { isGithubActionsAvailable } from "@backstage-community/plugin-github-actions";

import cicdContent from "../../common/cicdContent";
import overviewContent from "../../common/overviewContent";

export default (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {overviewContent}
    </EntityLayout.Route>
    <EntityLayout.Route
      path="/ci-cd"
      title="CI/CD"
      if={isGithubActionsAvailable}
    >
      {cicdContent}
    </EntityLayout.Route>
  </EntityLayout>
);
